import React from 'react';
import styled from 'styled-components';

import ResultPreview from '../../../containers/dashboards/preview/ResultPreview';
import { CANCEL_REQUEST_MESSAGE, FETCH_ERROR } from '../../../constants/common';
import SpinnerWithButton from '../../common/SpinnerWithButton';

const StyledErrorResult = styled.div`
  color: red;
  font-weight: bold;
  text-align: center;
`;

const StyledWarningResult = styled.div`
  color: blue;
  font-weight: bold;
  text-align: center;
`;

const StyledPreviewWrapper = styled.div`
  position: relative;
  height: calc(100% - 50px);
  width: 100%;

  .chart-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    text-align: center;
  }
`;

const UnitCardResult = ({
  isExecute,
  setChart,
  unit,
  unitsExecution,
  hasError,
  onRequestCancel,
  requestCanceled,
  cancelButtonDisabled,
}) => {
  if (isExecute) {
    return (
      <SpinnerWithButton
        onClick={onRequestCancel}
        disabled={cancelButtonDisabled}
        className="template-spinner"
      />
    );
  }

  if (hasError && requestCanceled) {
    return <StyledWarningResult>{CANCEL_REQUEST_MESSAGE}</StyledWarningResult>;
  }

  if (hasError) {
    return <StyledErrorResult>{FETCH_ERROR}</StyledErrorResult>;
  }

  if (!unitsExecution?.[unit.id]) {
    return null;
  }

  return (
    <StyledPreviewWrapper className="preview-wrapper">
      <div className="chart-wrapper st-retention-view">
        <ResultPreview setChart={setChart} setShow={() => {}} unit={unit} />
      </div>
    </StyledPreviewWrapper>
  );
};

export default UnitCardResult;
